import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/error-icon.svg'
import _imports_1 from '@/assets/add-file.svg'
import _imports_2 from '@/assets/add-layer.svg'
import _imports_3 from '@/assets/delete.svg'
import _imports_4 from '@/assets/settings.svg'


const _withScopeId = n => (_pushScopeId("data-v-384e5b31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layers d-flex flex-column" }
const _hoisted_2 = { class: "tabs d-flex flex-row" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 2,
  class: "ms-auto d-flex"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 3,
  class: "ms-auto d-flex"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 0,
  class: "child-layers"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "ms-auto d-flex" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "no-data d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  key: 0,
  class: "footer d-flex flex-row-reverse"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]

import { PropType, watch, computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { useAppStateStore } from "@/store/app-state";

import NewLayerDialog from "../Modals/NewLayerDialog.vue";

import { LayerItemType } from "@/classes/data-structures/layer-item-type";
import { ViewType } from "@/classes/data-structures/view-type";
import { ViewIndex } from "@/classes/data-structures/view-index";
import { LayerItem } from "@/classes/data-structures/layer-item";
import { LayerStatus } from "@/classes/data-structures/layer-status";
import Loading from "../Pages/Loading.vue";
import { useUserStore } from "@/store/user-store";
import { CustomViewer } from "@/classes/viewer/custom-viewer";
import { tenant } from "@/tenants/tenant";

declare var viewer: CustomViewer;


export default /*#__PURE__*/_defineComponent({
  __name: 'Layers',
  props: {
    viewIndex: {
        type: String as PropType<ViewIndex>,
        required: true,
        default: ViewIndex.View1,
    },
    enableEditing: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

let appState = useAppStateStore();
let userState = useUserStore();
let route = useRoute();
let newLayerDialog = ref(null);
const colorVersion = ref(0); // bump to refresh colors in list when profiles change
const volumeColorTick = ref(0); // bump to refresh colors in list when volumes change
const layersContent = ref<HTMLElement | null>(null);
const layerRefs = new Map<string, HTMLElement>();



const isProjectOwner = computed(() => {
    return appState.project?.user?.uuid === userState.state.user?.uuid;
});

/** Tabs **/
const tabs2d = [LayerItemType.Cad, LayerItemType.Orthophoto, LayerItemType.Profiles, LayerItemType.Volumes, LayerItemType.Annotations] as const;
const tabs3d = [LayerItemType.Cad, LayerItemType.PointClouds, LayerItemType.Meshes, LayerItemType.Profiles, LayerItemType.Volumes, LayerItemType.Annotations] as const;
const tabs = computed<LayerItemType[]>(() => (appState.viewType === ViewType.View2D ? [...tabs2d] : [...tabs3d]));

const selectedTab = computed(() => appState.getViewTab(props.viewIndex));

const selectedTabLayers = computed(() => {
    const layers = appState.getViewLayers(props.viewIndex, selectedTab.value);
    if (selectedTab.value !== LayerItemType.Profiles) return layers;

    const getProfilesForLayer = (layer: LayerItem): any[] => {
        const globalViewer: any = viewer as any;
        if (!layer?.children?.length || !globalViewer?.profiles) return [];
        const profiles: any[] = [];
        for (const child of layer.children) {
            const profile = globalViewer.profiles.find((p: any) => p.uuid === child.id || p.name === child.name);
            if (profile) profiles.push(profile);
        }
        return profiles;
    };

    const isTransverseLayer = (layer: LayerItem): boolean => {
        const profiles = getProfilesForLayer(layer);
        if (!profiles.length) return false;
        const cloudIds = new Set<string>();
        for (const profile of profiles) {
            const meta = (profile as any)?.userData ?? {};
            if (meta?.isCrossSection === true || meta?.profileType === "cross" || meta?.distance != null || meta?.parentId != null) {
                return true;
            }
            const cloudId = meta?.cloudId;
            if (cloudId != null && cloudId !== "") cloudIds.add(String(cloudId));
        }
        return cloudIds.size > 1;
    };

    const getOrderingInfo = (layer: LayerItem) => {
        let isCross = isTransverseLayer(layer);
        const profiles = getProfilesForLayer(layer);
        if (!profiles.length) {
            return {
                baseGroup: Number.POSITIVE_INFINITY,
                isCross,
                distance: Number.POSITIVE_INFINITY,
                name: layer.name || ""
            };
        }
        let baseGroup = Number.POSITIVE_INFINITY;
        let distance = Number.POSITIVE_INFINITY;
        const cloudIds = new Set<string>();
        for (const profile of profiles) {
            const meta = (profile as any)?.userData ?? {};
            if (typeof meta.baseGroupIndex === "number") {
                baseGroup = Math.min(baseGroup, meta.baseGroupIndex);
            } else if (typeof meta.groupIndex === "number") {
                baseGroup = Math.min(baseGroup, meta.groupIndex);
            }
            const candidates = [meta.distance, meta.distanceValue];
            for (const candidate of candidates) {
                const num = typeof candidate === "number" ? candidate : Number(candidate);
                if (Number.isFinite(num)) {
                    distance = Math.min(distance, num);
                }
            }
            if (meta?.isCrossSection === true || meta?.parentId != null || meta?.distance != null || meta?.distanceValue != null) {
                isCross = true;
            }
            const cloudId = meta?.cloudId;
            if (cloudId != null && cloudId !== "") {
                cloudIds.add(String(cloudId));
            }
        }
        if (!isCross && cloudIds.size > 1) {
            isCross = true;
        }
        if (!isCross) {
            distance = 0;
        }
        if (!Number.isFinite(baseGroup)) {
            const fallback = /group_(\d+)/i.exec(layer.id ?? "");
            if (fallback) {
                const parsed = parseInt(fallback[1], 10);
                if (Number.isFinite(parsed)) baseGroup = parsed;
            }
        }
        return {
            baseGroup,
            isCross,
            distance,
            name: layer.name || ""
        };
    };

    return [...layers].sort((a, b) => {
        const oa = getOrderingInfo(a);
        const ob = getOrderingInfo(b);
        if (oa.baseGroup !== ob.baseGroup) return oa.baseGroup - ob.baseGroup;
        if (oa.isCross !== ob.isCross) return oa.isCross ? 1 : -1;
        if (oa.distance !== ob.distance) return oa.distance - ob.distance;
        return oa.name.localeCompare(ob.name);
    });
});

/** Volume color helpers **/
function shouldShowLayerColor(layer: LayerItem): boolean {
    return selectedTab.value === LayerItemType.Volumes && layer.layerStatus === LayerStatus.ProcessedAndLoaded;
}

function getVolumeOverlayColorFromViewer(id: string): string {
    const viewerAny: any = (window as any).viewer;
    const vol = viewerAny?.volumes?.find((v: any) => v.uuid === id);
    const poly = vol?.children?.find((c: any) => c.name === "SelectionPolygon");
    const hexValue = poly?.userData?.color ?? 0xff0000;
    const numericRaw = typeof hexValue === "number" ? hexValue : parseInt(String(hexValue).replace("#", ""), 16);
    const numeric = Number.isFinite(numericRaw) ? numericRaw : 0xff0000;
    const hex = (numeric >>> 0).toString(16).padStart(6, "0");
    return `#${hex}`;
}

function layerColorStyle(layer: LayerItem): Record<string, string> {
    volumeColorTick.value; // ensure reactivity on updates
    const viewerAny: any = (window as any).viewer;
    if (viewerAny?.isVolumeHeatmapEnabled?.(layer.id)) {
        return {
            background: "linear-gradient(180deg, #ff0000 0%, #ffff00 35%, #90caf9 70%, #0d47a1 100%)"
        };
    }
    return {
        background: getVolumeOverlayColorFromViewer(layer.id)
    };
}

function handleVolumeAppearanceChanged(){
    volumeColorTick.value++;
}

/** Profile color helpers **/
function getProfileColorStyle(childLayer: LayerItem): string {
    colorVersion.value; // reactive dep
    if (selectedTab.value !== LayerItemType.Profiles || !viewer?.profiles) return "background-color: #ffffff;";

    const profile = viewer.profiles.find((p: any) => p.uuid === childLayer.id || p.name === childLayer.name);
    if (profile?.getColorHex) return `background-color: #${profile.getColorHex()};`;
    return "background-color: #ffffff;";
}

function isLayerNameClickable(layer: LayerItem): boolean {
    // Only parent items (no parent) and only CAD or Profiles layers
    return !(layer as any).parent && (layer.layerType === LayerItemType.Cad || layer.layerType === LayerItemType.Profiles);
}

function findViewerObjectForLayer(layer: LayerItem): any | null {
    if (layer.layerType === LayerItemType.Profiles && layer.children?.length) {
        return { isProfileGroup: true, groupName: layer.name, layerItem: layer, elementType: "profileGroup" };
    }
    switch (layer.layerType) {
        case LayerItemType.Annotations:
            return viewer.annotations?.find((m: any) => m.uuid === layer.id) || null;
        case LayerItemType.Meshes:
            return viewer.meshes?.find((m: any) => m.uuid === layer.id) || null;
        case LayerItemType.PointClouds:
            return viewer.pointclouds?.find((m: any) => m.uuid === layer.id) || null;
        case LayerItemType.Profiles: {
            const byId = viewer.profiles?.find((p: any) => p.uuid === layer.id);
            if (byId) return byId;
            return viewer.profiles?.find((p: any) => p.name === layer.name || p.userData?.layerName === layer.name) || null;
        }
        case LayerItemType.Cad: {
            const ms = viewer.measurements?.filter((m: any) => m.layerName === layer.name) || [];
            return ms.length ? ms[0] : null;
        }
        default:
            return null;
    }
}

function setSelectedElementIfChanged(newSel: any) {
    const cur = appState.selectedElement;
    if (cur === newSel) return;

    const isEqual = (() => {
        if (!cur || !newSel) return false;
        if (cur.isProfileGroup || newSel.isProfileGroup) return !!cur?.isProfileGroup && !!newSel?.isProfileGroup && cur.groupName === newSel.groupName;
        if (cur.isMultiProfileSelection || newSel.isMultiProfileSelection) {
            if (!(cur?.isMultiProfileSelection && newSel?.isMultiProfileSelection)) return false;
            const idsA = new Set(cur.profiles?.map((p: any) => p.uuid));
            const idsB = new Set(newSel.profiles?.map((p: any) => p.uuid));
            if (idsA.size !== idsB.size) return false;
            for (const id of idsA) if (!idsB.has(id)) return false;
            return true;
        }
        return cur?.constructor?.name === "Profile" && newSel?.constructor?.name === "Profile" && cur.uuid === newSel.uuid;
    })();

    if (!isEqual) {
        (viewer as any)?.deselectElement?.();
        (viewer as any).selectedElement = newSel;
        (viewer as any)?.onSelectedElementChanged?.emit?.(newSel);
        appState.selectedElement = newSel || null;
    }
}

/** Actions **/
function selectTab(tab: LayerItemType) {
    appState.setViewTab(props.viewIndex, tab);
}

function getTabIconClass(tab: LayerItemType): string {
    switch (tab) {
        case LayerItemType.Orthophoto:
            return "ortho";
        case LayerItemType.Meshes:
            return "mesh";
        case LayerItemType.PointClouds:
            return "cloud";
        case LayerItemType.Cad:
            return "cad";
        case LayerItemType.Annotations:
            return "annotations";
        case LayerItemType.Profiles:
            return "profile";
        case LayerItemType.Volumes:
            return "volume";
        default:
            return tab.toLowerCase().replace(" ", "-");
    }
}

function toggleExpanded(layer: LayerItem) {
    layer.expanded = !layer.expanded;
}

function getLayerClasses(layer: LayerItem) {
    return [appState.activeProfileLayer?.id === layer.id ? "active" : "", layer.layerStatus !== LayerStatus.ProcessedAndLoaded ? "unavailable" : ""];
}

function zoomToSelected(layer: LayerItem) {
    viewer?.zoomToFitLayer?.(layer);
}

function toggleLayerVisibility(layer: LayerItem) {
    if (selectedTab.value === LayerItemType.Profiles) {
        const newVisibility = !layer.visible;
        layer.visible = newVisibility;
        if (layer.children) {
            layer.children.forEach((child) => {
                child.visible = newVisibility;
                viewer?.updateProfileVisibility?.(child.id, newVisibility);
            });
        }
        document.dispatchEvent(new CustomEvent("profile-visibility-changed"));
        return;
    }

    appState.toggleLayer(layer.id, selectedTab.value, props.viewIndex);
}

function toggleChildLayerVisibility(childLayer: LayerItem, parentLayer: LayerItem) {
    childLayer.visible = !childLayer.visible;
    viewer?.updateProfileVisibility?.(childLayer.id, childLayer.visible);
    const hasVisibleChildren = parentLayer.children?.some((c) => c.visible) ?? false;
    parentLayer.visible = hasVisibleChildren;
    document.dispatchEvent(new CustomEvent("profile-visibility-changed"));
}

function onLayerClicked(layer: LayerItem) {
    if (selectedTab.value === LayerItemType.Cad) {
        appState.setActiveCadLayer(layer);
    }

    if (layer.layerType === LayerItemType.Profiles && layer.children?.length) {
        // select all child profiles as a group
        const selectedProfiles: any[] = [];
        for (const child of layer.children) {
            const p = viewer.profiles?.find((pp: any) => pp.uuid === child.id || pp.name === child.name);
            if (p) {
                selectedProfiles.push(p);
            }
        }
        const groupObj = { isProfileGroup: true, groupName: layer.name, layerItem: layer, elementType: "profileGroup" };
        setSelectedElementIfChanged(groupObj);
        for (const p of selectedProfiles) {
            viewer?.selectObject?.(p, true);
            if (viewer.selectedProfiles && !viewer.selectedProfiles.includes(p)) viewer.selectedProfiles.push(p);
        }
        return;
    }

    const obj = findViewerObjectForLayer(layer);
    if (!obj) return;
    viewer?.selectObject?.(obj as any, true);
    setSelectedElementIfChanged(obj);
}

function isProfileGroupSelected(layer: LayerItem): boolean {
    const sel = appState.selectedElement as any;
    return !!sel?.isProfileGroup && sel.groupName === layer.name;
}

function setLayerRef(layerId: string, el: any) {
    if (el) {
        layerRefs.set(layerId, el);
    } else {
        layerRefs.delete(layerId);
    }
}

function scrollToLayer(layerId: string) {
    const element = layerRefs.get(layerId);
    if (element && layersContent.value) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

/** Uploads / CAD **/
async function addDataToSelectedTab() {
    const routeData = router.resolve({ name: "edit", params: { projectId: route.params.projectId, surveyId: route.params.surveyId }, query: { openUpload: selectedTab.value } });
    window.open(routeData.href, "_blank");
}

async function addNewCadLayer() {
    const layerName = await newLayerDialog.value?.show?.();
    if (layerName && layerName.length > 0) viewer?.addCadLayer?.(layerName);
}

function removeSelectedCadLayer() {
    if (appState.activeCadLayer?.name) viewer?.deleteCadLayer?.(appState.activeCadLayer.name);
}

function editProject() {
    const routeData = router.resolve({ name: "edit", params: { projectId: appState.project.uuid, surveyId: appState.view1Survey.uuid } });
    window.open(routeData.href, "_blank");
}

/** Profiles multi-select **/
const selectedProfileIds = ref<Set<string>>(new Set());
const selectedProfileArray = ref<string[]>([]);

function onChildLayerClicked(childLayer: LayerItem, parentLayer: LayerItem, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const multi = event.ctrlKey || event.metaKey; // no global key listeners needed
    if (multi) {
        handleProfileMultiSelection(childLayer, parentLayer);
    } else {
        clearMultiSelection();
        selectedProfileIds.value.add(childLayer.id);
        selectedProfileArray.value = Array.from(selectedProfileIds.value);
        updateViewerMultiSelection();
    }
}

function handleProfileMultiSelection(childLayer: LayerItem, parentLayer: LayerItem) {
    if (selectedProfileIds.value.has(childLayer.id)) {
        selectedProfileIds.value.delete(childLayer.id);
        selectedProfileArray.value = Array.from(selectedProfileIds.value);
    } else {
        if (selectedProfileIds.value.size > 0) {
            const firstSelectedId = selectedProfileArray.value[0];
            let existingParentLayer: LayerItem | null = null;
            for (const layer of appState.view1Layers) {
                const foundChild = layer.children?.find((c) => c.id === firstSelectedId);
                if (foundChild) { existingParentLayer = layer; break; }
            }
            if (existingParentLayer && existingParentLayer.name !== parentLayer.name) {
                // Prevent mixing incompatible profile types
                return;
            }
        }
        selectedProfileIds.value.add(childLayer.id);
        selectedProfileArray.value = Array.from(selectedProfileIds.value);
    }
    updateViewerMultiSelection();
}

function clearMultiSelection() {
    selectedProfileIds.value.clear();
    selectedProfileArray.value = [];
    viewer?.deselectElement?.();
}

function updateViewerMultiSelection() {
    if (selectedProfileIds.value.size === 0) {
        setSelectedElementIfChanged(null);
        return;
    }

    if (selectedProfileIds.value.size === 1) {
        const id = Array.from(selectedProfileIds.value)[0];
        const profileObject = viewer.profiles?.find((p: any) => p.uuid === id || p.name === id);
        if (profileObject) {
            setSelectedElementIfChanged(profileObject);
            viewer?.selectObject?.(profileObject, true);
            if (viewer.selectedProfiles && !viewer.selectedProfiles.includes(profileObject)) viewer.selectedProfiles.push(profileObject);
        }
        return;
    }

    const selectedProfiles: any[] = [];
    for (const id of selectedProfileIds.value) {
        const p = viewer.profiles?.find((pp: any) => pp.uuid === id || pp.name === id);
        if (p) selectedProfiles.push(p);
    }
    if (selectedProfiles.length) {
        const multiSelection = { isMultiProfileSelection: true, profiles: selectedProfiles, elementType: "multiProfile" };
        setSelectedElementIfChanged(multiSelection);
        for (const p of selectedProfiles) {
            viewer?.selectObject?.(p, true);
            if (viewer.selectedProfiles && !viewer.selectedProfiles.includes(p)) viewer.selectedProfiles.push(p);
        }
    }
}

/** Lifecycle **/
function onViewTypeChanged() {
    const availableTabs = tabs.value;
    if (!availableTabs.includes(selectedTab.value)) {
        for (const tab of availableTabs) {
            const layers = appState.getViewLayers(props.viewIndex, tab);
            if (layers.length > 0) { appState.setViewTab(props.viewIndex, tab); break; }
        }
    }
}

onMounted(() => {
    // React when the view type changes
    watch(
        () => appState.viewType,
        () => onViewTypeChanged(),
        { immediate: true }
    );

    // Sync selection coming from outside (e.g., 3D view)
    watch(
        () => appState.selectedElement,
        (newElement: any) => {
            colorVersion.value++; // re-render colors / selection
            if (!newElement) {
                selectedProfileIds.value.clear();
                selectedProfileArray.value = [];
                return;
            }
            // Check if it's a Profile instance by checking for Profile-specific properties
            const isProfile = typeof newElement === "object" && "chartPoints" in newElement && Array.isArray(newElement.chartPoints);
            if (isProfile) {
                selectedProfileIds.value.clear();
                selectedProfileIds.value.add(newElement.uuid);
                selectedProfileArray.value = [newElement.uuid];
                return;
            }
            if (newElement.isMultiProfileSelection) {
                selectedProfileIds.value.clear();
                for (const p of newElement.profiles) selectedProfileIds.value.add(p.uuid);
                selectedProfileArray.value = Array.from(selectedProfileIds.value);
            }
            // For profile groups highlight is handled via isProfileGroupSelected
        },
        { immediate: false }
    );

    const onProfileColorChanged = () => { colorVersion.value++; };
    document.addEventListener("profile-color-changed", onProfileColorChanged as any);
    (window as any).__layers_onProfileColorChanged = onProfileColorChanged;

    const onProfileDeselected = () => {
        clearMultiSelection();
        setTimeout(() => { colorVersion.value++; }, 10);
    };
    document.addEventListener("profile-deselected", onProfileDeselected as any);
    (window as any).__layers_onProfileDeselected = onProfileDeselected;

    // Volume color change listener
    window.addEventListener("volume-overlay-color-changed", handleVolumeAppearanceChanged);

    // Profile group selection from 3D scene
    const onProfileGroupSelected = (event: CustomEvent) => {
        const { groupName, layerItem } = event.detail;
        if (layerItem && selectedTab.value === LayerItemType.Profiles) {
            // Switch to profiles tab if not already there
            if (selectedTab.value !== LayerItemType.Profiles) {
                selectTab(LayerItemType.Profiles);
            }
            // Scroll to the layer after a small delay to ensure DOM is updated
            setTimeout(() => {
                scrollToLayer(layerItem.id);
            }, 100);
        }
    };
    document.addEventListener("profile-group-selected", onProfileGroupSelected as any);
    (window as any).__layers_onProfileGroupSelected = onProfileGroupSelected;
});

onUnmounted(() => {
    const colorHandler = (window as any).__layers_onProfileColorChanged;
    if (colorHandler) document.removeEventListener("profile-color-changed", colorHandler as any);

    const deselectedHandler = (window as any).__layers_onProfileDeselected;
    if (deselectedHandler) document.removeEventListener("profile-deselected", deselectedHandler as any);

    const groupSelectedHandler = (window as any).__layers_onProfileGroupSelected;
    if (groupSelectedHandler) document.removeEventListener("profile-group-selected", groupSelectedHandler as any);

    window.removeEventListener("volume-overlay-color-changed", handleVolumeAppearanceChanged);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab d-flex flex-column align-items-center", [tab === _unref(selectedTab) ? 'selected' : '']]),
          key: tab,
          onClick: ($event: any) => (selectTab(tab))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['tab-icon', getTabIconClass(tab)])
          }, null, 2),
          _createElementVNode("span", _hoisted_4, _toDisplayString(tab), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "content flex-grow-1",
      ref_key: "layersContent",
      ref: layersContent
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(selectedTabLayers).length > 0 ? 'visible' : '')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTabLayers), (layer) => {
          return (_openBlock(), _createElementBlock("div", {
            key: layer.id
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["layer-item d-flex flex-row align-items-center", [getLayerClasses(layer), { 'group-selected': isProfileGroupSelected(layer) }]]),
              onClick: ($event: any) => (onLayerClicked(layer)),
              ref_for: true,
              ref: el => setLayerRef(layer.id, el)
            }, [
              (layer.children)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["expand-toggle", [layer.expanded ? 'expanded' : 'collapsed']]),
                    onClick: _withModifiers(($event: any) => (toggleExpanded(layer)), ["stop"])
                  }, null, 10, _hoisted_6))
                : _createCommentVNode("", true),
              (shouldShowLayerColor(layer))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "layer-color-dot",
                    style: _normalizeStyle(layerColorStyle(layer))
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(['layer-name', isLayerNameClickable(layer) ? 'clickable' : '']),
                onClick: _withModifiers(($event: any) => (onLayerClicked(layer)), ["stop"])
              }, _toDisplayString(layer.name), 11, _hoisted_7),
              (layer.layerStatus == _unref(LayerStatus).ProcessedAndLoaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "zoom-to-fit",
                      onClick: _withModifiers(($event: any) => (zoomToSelected(layer)), ["stop"])
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", {
                      class: _normalizeClass(['layer-visibility', layer.visible ? 'visible' : '']),
                      onClick: _withModifiers(($event: any) => (toggleLayerVisibility(layer)), ["stop"])
                    }, null, 10, _hoisted_10)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (layer.layerStatus == _unref(LayerStatus).Loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(Loading, {
                            size: 18,
                            borderSize: 2
                          })
                        ]))
                      : (layer.layerStatus == _unref(LayerStatus).Error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(layer.layerStatus), 1))
                  ]))
            ], 10, _hoisted_5),
            (layer.children && layer.expanded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layer.children, (childLayer) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: childLayer.id,
                      class: _normalizeClass(["layer-item child-layer d-flex flex-row align-items-center", [getLayerClasses(childLayer), { 'profile-selected': selectedProfileArray.value.includes(childLayer.id) }]])
                    }, [
                      (_unref(selectedTab) === _unref(LayerItemType).Profiles)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "profile-color-indicator",
                            style: _normalizeStyle(getProfileColorStyle(childLayer))
                          }, null, 4))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "layer-name clickable",
                        onClick: _withModifiers(($event: any) => (onChildLayerClicked(childLayer, layer, $event)), ["stop"])
                      }, _toDisplayString(childLayer.name), 9, _hoisted_18),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", {
                          class: "zoom-to-fit",
                          onClick: ($event: any) => (zoomToSelected(childLayer))
                        }, null, 8, _hoisted_20),
                        _createElementVNode("div", {
                          class: _normalizeClass(['layer-visibility', childLayer.visible ? 'visible' : '']),
                          onClick: ($event: any) => (toggleChildLayerVisibility(childLayer, layer))
                        }, null, 10, _hoisted_21)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 2),
      (_unref(selectedTabLayers).length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", null, "No data available for " + _toDisplayString(_unref(selectedTab)) + ".", 1),
            (_unref(selectedTab) === _unref(LayerItemType).Annotations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Select annotation tool to add new annotations"))
              : _createCommentVNode("", true),
            (_unref(selectedTab) === _unref(LayerItemType).Profiles)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Upload profiles from " + _toDisplayString(_unref(tenant).desktopAppName), 1))
              : _createCommentVNode("", true),
            (_unref(selectedTab) === _unref(LayerItemType).Volumes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Upload volumes from " + _toDisplayString(_unref(tenant).desktopAppName), 1))
              : _createCommentVNode("", true),
            (_unref(selectedTab) !== _unref(LayerItemType).Annotations && _unref(selectedTab) !== _unref(LayerItemType).Profiles && _unref(selectedTab) !== _unref(LayerItemType).Volumes && _unref(isProjectOwner))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addDataToSelectedTab())),
                  class: "btn-link"
                }, " Upload new data "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (props.enableEditing && _unref(selectedTab) !== _unref(LayerItemType).Annotations && _unref(selectedTab) !== _unref(LayerItemType).Profiles && _unref(selectedTab) !== _unref(LayerItemType).Volumes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (_unref(selectedTab) !== _unref(LayerItemType).Cad && _unref(isProjectOwner))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "icon-btn d-flex",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (addDataToSelectedTab()))
              }, _hoisted_28))
            : _createCommentVNode("", true),
          (_unref(selectedTab) === _unref(LayerItemType).Cad)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "icon-btn d-flex",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addNewCadLayer()))
              }, _hoisted_30))
            : _createCommentVNode("", true),
          (_unref(selectedTab) === _unref(LayerItemType).Cad)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "icon-btn d-flex",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (removeSelectedCadLayer()))
              }, _hoisted_32))
            : _createCommentVNode("", true),
          (_unref(isProjectOwner))
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                class: "icon-btn d-flex me-auto",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (editProject()))
              }, _hoisted_34))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(NewLayerDialog, {
      ref_key: "newLayerDialog",
      ref: newLayerDialog
    }, null, 512)
  ]))
}
}

})